import { Modal } from './styles';
import { useEffect } from 'react';
import styled from 'styled-components';


export function CustomModal(props: any) {
  const {
    children,
    centered = true,
    size = 'auto',
    header,
    footer,
    ...rest
  } = props;

  useEffect(() => {
    if (props.opened) {
      // Simple scroll prevention for modal
      document.body.style.overflow = 'hidden';
    } else {
      // Restore scrolling
      document.body.style.overflow = '';
    }

    return () => {
      // Cleanup on unmount
      document.body.style.overflow = '';
    };
  }, [props.opened]);

  return (
    <Modal
      size={size}
      trapFocus={false}
      centered={centered}
      radius="8px"
      overlayColor="#000000"
      overlayOpacity={0.6}
      overlayBlur={4}
      transition="fade"
      transitionDuration={200}
      {...rest}
    >
      {header && <Modal.Header>{header}</Modal.Header>}
      <Modal.Body>
        <div className="modal-content-wrapper">
          <div>{children}</div>
          {footer && <div className="modal-footer">{footer}</div>}
        </div>
      </Modal.Body>
    </Modal>
  );
}
